module.exports = __webpack_public_path__ + "static/img/login_news01.804da701.png";